export function buildOpportunityCampaignName(title) {
    const now = new Date();
    const month = now.toLocaleString("en-US", { month: "short" });
    const year = String(now.getFullYear()).slice(-2);
    const safeTitle = (title || "Untitled").trim();

    return `Opportunity Campaign - ${safeTitle} - ${month}-${year}`;
}

export function buildOpportunityCampaignNameFromList(opportunities = []) {
    if (opportunities.length === 1) {
        return buildOpportunityCampaignName(opportunities[0]?.title);
    }

    const now = new Date();
    const month = now.toLocaleString("en-US", { month: "short" });
    const year = String(now.getFullYear()).slice(-2);

    return `Opportunity Campaign - ${opportunities.length} opportunities - ${month}-${year}`;
}
